import {DeserializedRecord, deserializeItem, Deserializer, deserializeSingleRelationship, JSONAPIRecord, JSONAPISingleRelationship} from "../Helpers";
import {Tag} from "../Tag";

interface SurveyTag extends DeserializedRecord {
  tag: Tag
}

interface SurveyTagData extends JSONAPIRecord {
  relationships: {
    tag: JSONAPISingleRelationship
  }
}

const deserializeSurveyTag: Deserializer<SurveyTag, SurveyTagData> = (data, included) => {
  const tag = deserializeSingleRelationship<Tag>(data.relationships.tag, included);

  return {
    tag: tag,
    tagId: data.relationships.tag.data.id,
    ...deserializeItem(data)
  };
};

export {
  deserializeSurveyTag, SurveyTag
};
